import React from "react";
import "./snackbar.scss";
import Snackbar from "@mui/material/Snackbar";
import ICON_COMPLETE from "../../assets/images/check-green.svg";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface SnackbarProps {
    open: boolean;
    message: string;
    severity: "success" | "error";
    duration: number;
    onClose: () => void;
}

const CustomSnackbar: React.FC<SnackbarProps> = ({ open, message, severity, duration, onClose }) => {
    return (
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={open}
            autoHideDuration={duration}
            onClose={onClose}
        >
            <div className="snackbar">
                {severity === "success" ? (
                    <>
                        <img src={ICON_COMPLETE} width={29} height={29} alt="Success Icon" />
                        <span className="ms-2">{message}</span>
                    </>
                ) : (
                    <>
                        <ErrorOutlineIcon />
                        <span className="ms-2">
                            {message || 'เกิดข้อผิดพลาดบางประการ กรุณาลองอีกครั้ง'}
                        </span>
                    </>
                )}
            </div>
        </Snackbar>
    );
};

export default CustomSnackbar;
